import React from 'react'
import { useNavigate } from 'react-router-dom'
import LOGO from '../../assets/pillarThera.png'

const SignupHeader = ({ navigetUrl }: { navigetUrl?: string }) => {
  const navigate = useNavigate()

  const handlePatientLogin = () => {
    navigate(navigetUrl || '/patient-login')
  }

  return (
    <header className="w-full bg-white shadow-sm relative z-[999]">
      <div className="flex items-center justify-between px-6 py-4 mx-auto">
        {/* <h1 className="text-2xl font-bold text-[#26a65b]">PillarThera</h1> */}
        <img
          src={LOGO}
          alt="LOGO"
          style={{
            width: 'auto',
            height: '3.5rem',
          }}
        />
        <button
          className="px-4 py-2 text-sm transition border border-gray-300 rounded-full cursor-pointer hover:bg-gray-100"
          onClick={handlePatientLogin}
        >
          Sign Up / Login
        </button>
      </div>
    </header>
  )
}

export default SignupHeader
